import * as React from 'react';
import { FC } from 'react';

import { ILinkWidgetFragment } from 'generated/sanity-graphql';

import { LinksContainer, StyledAnchor, StyledLink } from './loyalty-links-widget.styled';

interface ILinksWidgetProps {
  links: ILinkWidgetFragment[];
}

const LoyaltyLinksWidget: FC<ILinksWidgetProps> = ({ links }: ILinksWidgetProps) => {
  if (!links.length) {
    return null;
  }

  const isExternal = (url: string) => /^https?:\/\//.test(url);
  const CustomLink = (props: { url: string; label?: string | null }) =>
    isExternal(props.url) ? (
      <StyledAnchor href={props.url} target="_blank">
        {props.label}
      </StyledAnchor>
    ) : (
      <StyledLink to={props.url}>{props.label}</StyledLink>
    );

  return (
    <LinksContainer>
      {links.map((link, idx) =>
        link.link?.locale ? (
          <CustomLink url={link.link.locale} key={link._key ?? idx} label={link.text?.locale} />
        ) : null
      )}
    </LinksContainer>
  );
};

export default LoyaltyLinksWidget;
